import { render, staticRenderFns } from "./OutLinkPhone.vue?vue&type=template&id=6e24ff1e&scoped=true&"
import script from "./OutLinkPhone.vue?vue&type=script&lang=js&"
export * from "./OutLinkPhone.vue?vue&type=script&lang=js&"
import style0 from "./OutLinkPhone.vue?vue&type=style&index=0&id=6e24ff1e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e24ff1e",
  null
  
)

export default component.exports